import useTranslation from 'next-translate/useTranslation';
import { Col, Form } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import PasswordStrength from 'react-password-strength-bar';
import { TextField } from '@components/Form/TextField';
import styles from './LoginData.module.scss';

export const LoginData = () => {
  const { t } = useTranslation('register');

  const formikContext = useFormikContext<any>();

  const password = formikContext.values.password || '';

  const isPasswordLongEnough = password.length >= 12;
  // const hasUpperCaseLetter = password.match(/[A-Z]/);
  // const hasLowerCaseLetter = password.match(/[a-z]/);
  // const hasNumber = password.match(/[0-9]/);

  return (
    <Form.Group>
      <Form.Row>
        <Form.Group as={Col}>
          <h2 className="h2">{t('title.logindata')}</h2>
          <p className="font-weight-bold">{t('subtitle.logindata')}</p>
        </Form.Group>
      </Form.Row>

      <Form.Row>
        <Form.Group as={Col} xs={12}>
          <TextField label={t('label.username')} type="text" name="username" />
        </Form.Group>
      </Form.Row>

      <Form.Row>
        <Form.Group as={Col} xs={12} md={6}>
          <TextField label={t('label.password')} type="password" name="password" />

          <PasswordStrength
            password={password ?? ''}
            barColors={['#ddd', '#dc3545', '#ffcf01', '#8cc640', '#28a745']}
            scoreWords={[
              t('password-strength:very-weak'),
              t('password-strength:weak'),
              t('password-strength:reasonable'),
              t('password-strength:good'),
              t('password-strength:very-good')
            ]}
            shortScoreWord={t('password-strength:too-short')}
            minLength={12}
            className={styles.passwordStrength}
          />

          <TextField label={t('label.repeat-password')} type="password" name="repeatPassword" />
        </Form.Group>
        <Form.Group as={Col} xs={12} md={6}>
          <div>
            <Form.Label>{t('title.password-requirements')}</Form.Label>

            <ul className="list-unstyled">
              <li className={`${styles.item} ${isPasswordLongEnough ? styles.success : ''}`}>
                {t('password-long-enough', { length: 12 })}
              </li>
              {/*
              <li className={`${styles.item} ${hasUpperCaseLetter ? styles.success : ''}`}>{t('password-one-uppercase')}</li>
              <li className={`${styles.item} ${hasLowerCaseLetter ? styles.success : ''}`}>{t('password-one-lowercase')}</li>
              <li className={`${styles.item} ${hasNumber ? styles.success : ''}`}>{t('password-one-number')}</li>
            */}
            </ul>
          </div>
        </Form.Group>
      </Form.Row>
    </Form.Group>
  );
};
